/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-04-15 19:46:00
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-29 11:20:31
 */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './config/filter'
import  './index.css'


ReactDOM.render(<App />, document.getElementById('root'));

